import * as Sentry from '@sentry/browser';
import { useCookies } from 'react-cookie';

import {
  PropertyCharacteristicListItem,
  SupportPropertyCharacteristics,
} from '@type-def_iqfu/PropertyCharacteristicsType';

const backendBasePath = process.env.NEXT_PUBLIC_DEV_BACKEND_URL;

export type UpdatePurchaseInfoPayload = {
  max_building_age: null | number;
  max_price: null | number;
  b2b_availability: boolean;
  property_type_ids: number[];
  property_characteristic_ids: number[];
};

export type PurchaseAgencyUserType = 'admin' | 'company';

type PurchaseInfo = {
  id: number | null;
  company_id?: number;
  max_building_age: number | null;
  max_price: number | null;
  b2b_availability: boolean | null;
  support_property_types: PropertyCharacteristicListItem[] | null;
  support_property_characteristics: SupportPropertyCharacteristics;
};

const buildBasePath = (userType: PurchaseAgencyUserType, company_id: string) => {
  const namespace = userType === 'admin' ? 'admin' : 'company';
  return `${backendBasePath}/${namespace}/companies/${company_id}/purchase_agency_detail`;
};

export const usePurchaseAgency = (userType: PurchaseAgencyUserType = 'admin') => {
  const [cookies] = useCookies(['expiry', 'access-token', 'client', 'uid', 'user-type']);

  const getPurchaseInfo = async (company_id: string): Promise<PurchaseInfo | undefined> => {
    const url = buildBasePath(userType, company_id);

    return fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        uid: cookies['uid'],
        client: cookies['client'],
        'access-token': cookies['access-token'],
      },
    })
      .then((response) => response.json())
      .catch((error) => {
        Sentry.captureException(error);
        console.error('通信に失敗しました', error);
        return undefined;
      });
  };

  const updatePurchaseInformation = async (
    payload: UpdatePurchaseInfoPayload,
    company_id: string,
  ): Promise<{ success: boolean } | undefined> => {
    const url = buildBasePath(userType, company_id);

    return fetch(url, {
      method: 'PATCH',
      mode: 'cors',
      headers: {
        uid: cookies['uid'],
        client: cookies['client'],
        'access-token': cookies['access-token'],
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .catch((error) => {
        Sentry.captureException(error);
        console.error('通信に失敗しました', error);
        return undefined;
      });
  };

  return {
    getPurchaseInfo,
    updatePurchaseInformation,
  };
};
